export const SORT_PREFIX = "orderBy." as const;
